import useUser from '@alltrails/context/hooks/useUser';
import { useExposureEvent } from '@alltrails/experiments';
import { useEffect } from 'react';

export default function useAdaChatbotExposure(menuIsOpen: boolean): void {
  const user = useUser();
  const sendExposure = useExposureEvent('web-growth-rm-global-ada-chatbot-support');

  useEffect(() => {
    if (user && menuIsOpen) {
      sendExposure();
    }
  }, [user, sendExposure, menuIsOpen]);
}
